import { EL_COL_TYPE_DIMENSION, EL_DIMENSION_ROLE_FREQUENCY, EL_DIMENSION_ROLE_GENERIC, EL_DIMENSION_ROLE_MEASURE, 
    EL_DIMENSION_ROLE_TERRITORY, EL_DIMENSION_ROLE_TIME } from "../constants";

export const getIconType = (role) => {   
    let iconType = "";    
    switch (role) {
    case EL_DIMENSION_ROLE_GENERIC:
        iconType = "bar-chart";
        break;
    case EL_DIMENSION_ROLE_FREQUENCY:
        iconType = "line-chart";
        break;
    case EL_DIMENSION_ROLE_MEASURE:
        iconType = "stock";
        break;
    case EL_DIMENSION_ROLE_TERRITORY:
        iconType = "global";
        break;
    case EL_DIMENSION_ROLE_TIME:
        iconType = "calendar";
        break;
    default:
        iconType = "";
    }
    return iconType;
};

export const dimensionsAreWellDefined = (t, structureColumns, codelists) => {

    let hasTerritorialDimension = false;
    let hasTimeDimension = false;
    let hasTerritorialDimensionTranslation = false;
    let hasTimeDimensionTranslation = false;
    for(let i = 0; i < (structureColumns || []).length; i++ ) {
        const dim = structureColumns[i];
        if (dim.type !== EL_COL_TYPE_DIMENSION) {
            continue;
        }
        if (dim.dimensionDefinition.role === null) {
            return false;
        }
        if (dim.dimensionDefinition.role === EL_DIMENSION_ROLE_TIME) {
            hasTimeDimension = true;
            if ((dim.translations || []).length > 0) {
              hasTimeDimensionTranslation = true;
            }
        } else {
            if (dim.dimensionDefinition.role !== EL_DIMENSION_ROLE_TIME) {
                if (dim.dimensionDefinition.association === null 
                    && (dim.translations || []).length === 0) {
                        return false;
                } else if (dim.dimensionDefinition.association !== null) {
                    if ( ! (codelists || []).some(codelist => 
                        codelist.id === dim.dimensionDefinition.association.id &&
                        codelist.agencyID === dim.dimensionDefinition.association.agencyID && 
                        codelist.version === dim.dimensionDefinition.association.version)) {
                            return false;
                        }
                }
            }
            if (dim.dimensionDefinition.role === EL_DIMENSION_ROLE_TERRITORY) {
                hasTerritorialDimension = true;
                if ((dim.translations || []).length > 0) {
                  hasTerritorialDimensionTranslation = true;
                }
            }
        }        
    }

    const messages = [];
    if (!hasTerritorialDimension) {
        messages.push(t('components.easyLoading.error.dimensions.territorialDimension'))
    };
    if (!hasTimeDimension) {
        messages.push(t('components.easyLoading.error.dimensions.timeDimension'))
    }
    if (hasTerritorialDimensionTranslation) {
      messages.push(t('components.easyLoading.error.dimensions.territorialDimensionTranslation'))
    }
    if (hasTimeDimensionTranslation) {
      messages.push(t('components.easyLoading.error.dimensions.timeDimensionTranslation'))
    }
    
    return {
       result: hasTerritorialDimension && hasTimeDimension 
               && !hasTerritorialDimensionTranslation && !hasTimeDimensionTranslation,
       messages: messages
    }
}



// WEBPACK FOOTER //
// ./src/components/easy-loading/dimensions-step/utils.js